(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:scrollPositionEmitter
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <scroll-position-emitter></scroll-position-emitter>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('scrollPositionEmitter', scrollPositionEmitter);

    function scrollPositionEmitter(EventManagerService) {
        return {
            restrict: 'A',
            replace: false,
            controllerAs: 'scrollPositionEmitter',
            link: function (scope, element, attrs) {
                var lastScrollLeft = 0,
                    lastScrollTop = 0,
                    scrollTop = 0,
                    scrollLeft = 0;

                element.on('scroll', function() {
                    scrollLeft = angular.element(element)[0].scrollLeft;
                    scrollTop = angular.element(element)[0].scrollTop;

                    if(lastScrollLeft != scrollLeft ){
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCROLL.SCROLL_LEFT_CHANGE, scrollLeft);
                    }else if(scrollTop != lastScrollTop){
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCROLL.SCROLL_TOP_CHANGE, scrollTop);
                    }
                    lastScrollLeft = scrollLeft;
                    lastScrollTop = scrollTop;
                })
            }
        };
    }
}());
